export const EQUITY_MARKET_DEFAULT_PAYMENT_DEADLINE = 5;
